// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3wxCG","inputDescription":"styles_inputDescription__1zIG4"};